'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var SPORTSBOOK_REDIRECT = 'sportsbook-redirect:event';

exports.SPORTSBOOK_REDIRECT = SPORTSBOOK_REDIRECT;
